import { timestampDate } from '@bufbuild/protobuf/wkt'
import { GridColDef } from '@mui/x-data-grid'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { UserWorkingTimeModelDto } from '@/generated/Messages/Basic_pb'

export const useUserDetailsWorkingTimeModelColumns =
    (): GridColDef<UserWorkingTimeModelDto>[] => {
        const { t } = useTranslation()

        return useMemo(
            () => [
                {
                    field: 'name',
                    headerName: t('common.workingTimeModel'),
                    valueGetter: (_, row) => row.workingTimeModel?.name,
                    flex: 1,
                },
                {
                    field: 'validFrom',
                    headerName: t('common.from'),
                    valueGetter: (_, row) =>
                        row.validFrom ?
                            t('common.dateOnly.short', {
                                value: timestampDate(row.validFrom),
                            })
                        :   undefined,
                    flex: 1,
                },
                {
                    field: 'validUntil',
                    headerName: t('common.to'),
                    valueGetter: (_, row) =>
                        row.validUntil ?
                            t('common.dateOnly.short', {
                                value: timestampDate(row.validUntil),
                            })
                        :   undefined,
                    flex: 1,
                },
            ],
            [t]
        )
    }
